'use client';

import { DragDropFileUpload } from '@/components/drag-drop-image-upload';
import type { Theme } from '@mui/material';
import type { SxProps } from '@mui/system/styleFunctionSx';
import { Controller, useFormContext } from 'react-hook-form';

interface Props<T> {
  name: string;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
  initialAspectRatio?: number;
  minPixel?: number;
  maxPixel?: number;
  canvasMode?: boolean;
  parser?: (value: T) => { url: string; width: number; height: number } | undefined;
  formatter?: (value: { url: string; width: number; height: number }) => T;
}

/**
 * RHFImageUpload - React Hook Form集成的图片上传组件
 *
 * 将DragDropFileUpload组件与React Hook Form集成，支持表单验证和默认值
 */
export function RHFImageUpload<T>({
  name,
  size = 'medium',
  sx,
  initialAspectRatio = 1,
  minPixel,
  maxPixel,
  canvasMode = false,
  formatter,
  parser,
  ...other
}: Props<T>) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DragDropFileUpload
          {...other}
          initialAspectRatio={initialAspectRatio}
          error={!!error}
          helperText={error?.message}
          size={size}
          sx={sx as any}
          minPixel={minPixel}
          maxPixel={maxPixel}
          canvasMode={canvasMode}
          value={parser ? parser(field.value) : field.value}
          onChange={(val) => field.onChange(formatter ? formatter(val) : val)}
        />
      )}
    />
  );
}
